import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_observe_any_of_the_following_practices_related_to_1'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_observe_any_of_the_following_practices_related_to_1',
  name: 'Does the facility observe any of the following practices related to the OSH committee?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
      text: 'Safety committee meetings are held on a monthly basis',
      externalIds: [
        {
          id: 'hs-17--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
      text: 'Safety committee meetings are held at least quarterly',
      externalIds: [
        {
          id: 'hs-17--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFORCE',
      text: 'Safety committee meeting minutes are shared with the workforce',
      externalIds: [
        {
          id: 'hs-17--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
      text: 'Safety committee meeting action items are tracked',
      externalIds: [
        {
          id: 'hs-17--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED_BY',
      text: 'Safety committee communicates complaints and problems shared by workers about OHS to upper management',
      externalIds: [
        {
          id: 'hs-hsc-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'UPPER_MANAGEMENT_RECOGNIZES_ACCEPTS_THE_SAFETY_COMMITTEE',
      text: 'Upper management recognizes/ accepts the safety committee',
      externalIds: [
        {
          id: 'hs-17--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_COMMITTEE_MEETS_TO_REVIEW_SAFETY_ISSUES_TRACK_CORRECTIVE',
      text: 'Safety committee meets to review safety issues, track corrective actions and identify opportunities for further improvement of safety conditions',
      externalIds: [
        {
          id: 'hs-17--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-17--1-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
                'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
                'SAFETY_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFORCE',
                'SAFETY_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
                'SAFETY_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED_BY',
                'UPPER_MANAGEMENT_RECOGNIZES_ACCEPTS_THE_SAFETY_COMMITTEE',
                'SAFETY_COMMITTEE_MEETS_TO_REVIEW_SAFETY_ISSUES_TRACK_CORRECTIVE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-hsc-8',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14470,
  sectionId: '2.2.9.3',
  impactArea: 'Engagement with OSH',
  impactAreaId: 'ENGAGEMENT_WITH_OHS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
